import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { pluginKey } from './plugin-key';
import { useResizeWidthObserver } from './useResizeWidthObserver';
function createPlugin(dispatch) {
  return new SafePlugin({
    key: pluginKey,
    state: {
      init: function init() {
        return {
          width: document.body.offsetWidth
        };
      },
      apply: function apply(tr, pluginState) {
        var meta = tr.getMeta(pluginKey);
        if (!meta) {
          return pluginState;
        }
        var newPluginState = _objectSpread(_objectSpread({}, pluginState), meta);
        if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
          dispatch(pluginKey, newPluginState);
          return newPluginState;
        }
        return pluginState;
      }
    }
  });
}
export var widthPlugin = function widthPlugin() {
  return {
    name: 'width',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'width',
        plugin: function plugin(_ref) {
          var dispatch = _ref.dispatch;
          return createPlugin(dispatch);
        }
      }];
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return undefined;
      }
      return pluginKey.getState(editorState);
    },
    usePluginHook: function usePluginHook(_ref2) {
      var editorView = _ref2.editorView,
        containerElement = _ref2.containerElement;
      return useResizeWidthObserver({
        editorView: editorView,
        containerElement: containerElement
      });
    }
  };
};